import React from 'react';
import { Box, Typography, Container, Grid, Divider } from '@mui/material';

const NosotrosGlossary = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <Box sx={{ pt: 0, pb: { xs: 8, md: 10 }, bgcolor: '#fbfcfd' }}>
            <Container maxWidth="lg">
                <Typography variant="h3" align="center" sx={{ mb: { xs: 5, md: 8 }, fontWeight: 800, color: '#4e429c' }}>
                    Glosario
                </Typography>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                    {data.map((item, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="body1" sx={{ lineHeight: 1.6, color: '#666' }}>
                                    <span style={{ fontWeight: 800, color: '#4e429c', marginRight: '8px' }}>
                                        {item.term}:
                                    </span>
                                    {item.definition}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default NosotrosGlossary;
